import Rule from 'components/Rule/Rule';
import { BodyM } from 'components/Typography/Typography';
import { dynamicTranslate } from 'components/Translation';
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/password/passwordRulesStyle';
import { useSelector } from 'react-redux';
import { getPasswordRulesLabels } from 'redux/modules/dynamicLabels/selectors';

interface IPasswordRulesProps {
	showErrors?: boolean;
	password: string;
	setRulePassed: (password: boolean) => void;
}

const PasswordRules: React.FC<IPasswordRulesProps> = ({ showErrors = false, password, setRulePassed }) => {
	const useStyles = makeStyles(styles);
	const passwordRules = useSelector(getPasswordRulesLabels);
	const classes = useStyles();
	function containsSequentialNums(chars: string) {
		const tests = [
			chars,
			chars
				.split('')
				.reverse()
				.join(''),
		];

		for (let ii in tests) {
			const s = tests[ii];

			for (let i = 0; i < s.length; i++) if (+s[+i + 1] === +s[i] + 1 && +s[+i + 2] === +s[i] + 2) return true;
		}
		return false;
	}
	const rules = [
		{
			name: dynamicTranslate(passwordRules.charactersLength, passwordRules.minLength),
			success: password.length >= passwordRules.minLength,
		},
		{
			name: passwordRules.uppercase,
			success: /[A-Z]+/.test(password),
		},
		{
			name: passwordRules.number,
			success: /[0-9]+/.test(password),
		},
		{
			name: passwordRules.specialCharacter,
			success: /[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\]/g.test(password),
		},
		{
			name: passwordRules.continuousNumber,
			success: /^(?!.*(?:password|123|234|345|456|567|678|789|890)).+$/.test(password),
		},
	];
	useEffect(() => {
		if (rules.every((rule) => rule.success)) {
			setRulePassed(true);
		} else {
			setRulePassed(false);
		}
	}, [password]);
	return (
		<div className={classes.passwordRules}>
			<BodyM>{passwordRules.mustContain}</BodyM>
			{rules.map((rule) => (
				<Rule showErrors={showErrors} key={rule.name} {...rule} />
			))}
		</div>
	);
};

export default PasswordRules;
